
export const SetupChildSliderEvent = "MovieTickets:SetupChildSlider";
export interface SetupChildSliderArgs {
	targetHash: string;
	syncTarget: string | null;
}

export const ScrollIntoViewEvent = "MovieTickets:ScrollIntoView";
